import { render, staticRenderFns } from "./TenantInfo.vue?vue&type=template&id=2a735aac&scoped=true&"
import script from "./TenantInfo.vue?vue&type=script&lang=js&"
export * from "./TenantInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenantInfo.vue?vue&type=style&index=0&id=2a735aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a735aac",
  null
  
)

export default component.exports